'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var react = require('react');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var getPobbleDomain = function getPobbleDomain() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var regex = /(\.pobble\.com|pobble\.co\.uk)/;
  var match = href.match(regex);
  if (!match) return null;
  return match[0].slice(1, match[0].length);
};

var getDomainPrefix = function getDomainPrefix() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var prefixMatch = href.match(/^(https:\/\/([a-z]+)-)(?=([a-z]+\.pobble\.(com|co\.uk)))/g);
  if (!prefixMatch) return '';
  var match = prefixMatch[0];
  return !match ? '' : match.split('https://')[1].slice(0, -1);
};

var getPobbleEnv = function getPobbleEnv() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var localhostMatch = href.match(/(http:\/\/(localhost|127\.0\.0\.1|192\.168.{1,}:30.{2}))/);
  if (localhostMatch) return 'local';
  var isPobble = !!getPobbleDomain();
  if (!isPobble) return null;
  var domainPrefix = getDomainPrefix(href);
  if (!domainPrefix || domainPrefix === 'prod') return 'prod';
  if (domainPrefix === 'stg') return 'stg';
};

var getErrorInfo = function getErrorInfo(e) {
  if (!e || !e.response) return {
    status: null,
    ref: null,
    msg: null
  };
  var info = {
    status: e.response.status
  };
  var errorDetails = !e.response.data || !e.response.data.errors || !e.response.data.errors.length ? {
    ref: null,
    msg: null
  } : {
    ref: e.response.data.errors[0].err || null,
    msg: e.response.data.errors[0].msg || null
  };
  return _objectSpread(_objectSpread({}, info), errorDetails);
};

var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var isTouchScreen = 'ontouchstart' in window || !!navigator.msMaxTouchPoints;

var usePrevious = function usePrevious(value) {
  var ref = react.useRef();
  react.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

exports.getDomainPrefix = getDomainPrefix;
exports.getErrorInfo = getErrorInfo;
exports.getPobbleDomain = getPobbleDomain;
exports.getPobbleEnv = getPobbleEnv;
exports.isIOS = isIOS;
exports.isTouchScreen = isTouchScreen;
exports.usePrevious = usePrevious;